/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mild_Keen_Fox_LeapInputs */

const en_mild_keen_fox_leap = /** @type {(inputs: Mild_Keen_Fox_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No segments match your search.`)
};

const de_mild_keen_fox_leap = /** @type {(inputs: Mild_Keen_Fox_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Segmente gefunden.`)
};

/**
* | output |
* | --- |
* | "No segments match your search." |
*
* @param {Mild_Keen_Fox_LeapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mild_keen_fox_leap = /** @type {((inputs?: Mild_Keen_Fox_LeapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mild_Keen_Fox_LeapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mild_keen_fox_leap(inputs)
	return de_mild_keen_fox_leap(inputs)
});